/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const checkTokenType =
  (context: any, event: any) => (callback: any, onEvent: any) => {
    let tokenType: string = 'sign-in';
    if (event?.data?.value?.signInToken) {
      tokenType = 'sign-in';
      context.signInRes = event?.data?.value;
    } else if (event?.data?.value?.accessToken) {
      tokenType = 'access';
      context.signInRes = event?.data?.value;
    }

    onEvent((e: any) => {
      switch (tokenType) {
        case 'sign-in':
          console.log(`method=checkTokenType sign-in`);
          callback('SIGN_IN_TOKEN', event?.data?.value);
          break;
        case 'access':
          console.log(`method=checkTokenType access`);
          callback('ACCESS_TOKEN', event?.data?.value);
          break;
        default:
          console.log(`method=checkTokenType tokenType=${tokenType} unknown`);
          callback('ERROR');
      }
    });
  };
